import { classes as defaultClasses } from '@wix/design-system-tokens/all.st.css';
import { classes as odeditorClasses } from '@wix/design-system-tokens/odeditor/all.st.css';
import { classes as odeditorDarkClasses } from '@wix/design-system-tokens/odeditor-dark/all.st.css';
import { classes as studioClasses } from '@wix/design-system-tokens/studio/all.st.css';
import { classes as wixelClasses } from '@wix/design-system-tokens/wixel/all.st.css';
import { WidgetTheme } from '@wix/wix-help-widget-common/types';

// WDS design-system-tokens root, which declares the `--wds-*` custom properties.
const TOKEN_ROOT_CLASS: Record<WidgetTheme, string> = {
  default: defaultClasses.root,
  studio: studioClasses.root,
  odeditor: odeditorClasses.root,
  'odeditor-dark': odeditorDarkClasses.root,
  wixel: wixelClasses.root,
};

/**
 * Plain companion class to the WDS token root, one per theme. Stylable root class
 * names are not addressable from SCSS, so the `--hw-*` palette blocks in
 * themes.scss and the studio2DarkTheme mixin gate on this class instead.
 */
export const getWidgetThemeClassName = (theme: WidgetTheme): string => `widget-theme-${theme}`;

// @wix/cc-user-facing-common-components gates its dark styles on this ancestor class (kb#6042).
const CC_COMPONENTS_DARK_CLASS = 'widget-dark-theme';

// Maps the resolved theme to the classes that carry its design tokens.
// Use getWidgetTheme() to resolve the theme from origin/init params first.
export const getDesignSystemClassName = (theme: WidgetTheme): string => {
  const classNames = `${TOKEN_ROOT_CLASS[theme]} ${getWidgetThemeClassName(theme)}`;
  return theme === 'odeditor-dark' ? `${classNames} ${CC_COMPONENTS_DARK_CLASS}` : classNames;
};
